class CartRemoveButton extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', (event) => {
			event.preventDefault();
			const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
			cartItems.updateQuantity(this.dataset.index, 0);
		});
	}
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();
		this.lineItemStatusElement =
			document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

		const debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, ON_CHANGE_DEBOUNCE_TIMER);

		this.addEventListener('change', debouncedOnChange.bind(this));
	}

	cartUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
			if (event.source === 'cart-items') {
				return;
			}
			this.onCartUpdate();
		});
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}

	onChange(event) {
		if (!event.target.classList.contains('recharge-cart-select')) { //VALIDACION PARA NO EJECUTAR UN CART UPDATE CUANDO SE CAMBIA EL INTERVAL DE SUBSCRIPTION
			this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
		}
	}

	onCartUpdate() {
		if (this.tagName === 'CART-DRAWER-ITEMS') {
			fetch(`${routes.cart_url}?section_id=cart-drawer`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
					for (const selector of selectors) {
						const targetElement = document.querySelector(selector);
						const sourceElement = html.querySelector(selector);
						if (targetElement && sourceElement) {
							targetElement.replaceWith(sourceElement);
						}
					}
				})
				.catch((e) => {
					console.error(e);
				});
		} else {
			fetch(`${routes.cart_url}?section_id=main-cart-items`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					const sourceQty = html.querySelector('cart-items');
					this.innerHTML = sourceQty.innerHTML;
				})
				.catch((e) => {
					console.error(e);
				});
		}
	}

	getSectionsToRender() {
		return [{
				id: 'main-cart-items',
				section: document.getElementById('main-cart-items').dataset.id,
				selector: '.js-contents',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
			{
				id: 'cart-live-region-text',
				section: 'cart-live-region-text',
				selector: '.shopify-section',
			},
			{
				id: 'main-cart-footer',
				section: document.getElementById('main-cart-footer').dataset.id,
				selector: '.js-contents',
			},
		];
	}

	updateQuantity(line, quantity, name, variantId) {
		this.enableLoading(line);

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_change_url}`, {
				...fetchConfig(),
				...{
					body
				}
			})
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				const quantityElement =
					document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
				const items = document.querySelectorAll('.cart-item');

				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute('value');
					this.updateLiveRegions(line, parsedState.errors);
					return;
				}

				this.classList.toggle('is-empty', parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector('cart-drawer');
				const cartFooter = document.getElementById('main-cart-footer');

				if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
				if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					);
				});
				const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
				let message = '';
				if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
					if (typeof updatedValue === 'undefined') {
						message = window.cartStrings.error;
					} else {
						message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
					}
				}
				this.updateLiveRegions(line, message);

				const lineItem =
					document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						?
						trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) :
						lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
				} else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
				}

				publish(PUB_SUB_EVENTS.cartUpdate, {
					source: 'cart-items',
					cartData: parsedState,
					variantId: variantId
				});
			})
			.catch(() => {
				this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
				const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
				errors.textContent = window.cartStrings.error;
			})
			.finally(() => {
				this.disableLoading(line);
			});
	}

	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
		if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

		this.lineItemStatusElement.setAttribute('aria-hidden', true);

		const cartStatus =
			document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
		cartStatus.setAttribute('aria-hidden', false);

		setTimeout(() => {
			cartStatus.setAttribute('aria-hidden', true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
		mainCartItems.classList.add('cart__items--disabled');

		const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
		const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute('aria-hidden', false);
	}

	disableLoading(line) {
		const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
		mainCartItems.classList.remove('cart__items--disabled');

		const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
		const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

		cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
		cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
	}
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
	customElements.define(
		'cart-note',
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					'change',
					debounce((event) => {
						const body = JSON.stringify({
							note: event.target.value
						});
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{
								body
							}
						});
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}

/*IMPROVING RECHARGE CODE START*/

function addSubscription(that)
{
	let cookieName = `_recharge_properties_${that.getAttribute('data-id')}`;
	let delivery_date = '';
	let original_price = '';

	if (that.hasAttribute('data-delivery-date')) {
		delivery_date = that.getAttribute('data-delivery-date');
	}

	if (that.hasAttribute('data-original-price')) {
		original_price = that.getAttribute('data-original-price');
	}

  console.log(">>> COOKIE NAME" , cookieName);

	getJsonCookie(cookieName)
		.then(subs_cookie => {
			return addToCartWithRechargeSub(
				that.getAttribute('data-product-id'),
				cartObj.route.change,
				subs_cookie,
				1,
				that.getAttribute('data-selling-id'),
				that.getAttribute('data-item'),
				delivery_date,
				original_price
			);
		})
		.then(secondResponse => {
			location.reload();
		})
		.catch(error => {
			console.log(">>> ERROR: ", error);
		});

}

function addBundleSubscription(that, bundle_handle, bundle_unique_id, intervals, plans, selectedInterval, title, price, image)
{
	let result = '';
	
	if(intervals.includes('months')) {
		result = intervals.match(/\d+/g).join(',');
		selectedInterval = selectedInterval.split(" ")[0];
	} else {
		result = intervals;
	}
	
	let newDate = addMonthToDate(selectedInterval);

	const product = that.getAttribute('data-id');
	const productPrice = (that.getAttribute('data-product-price') / 100).toFixed(2);
	const productName = that.getAttribute('data-product-name');

	const indexCart = that.getAttribute('data-item');
	const selling_plan = that.getAttribute('data-selling-id');
	const qty = document.getElementById(`Quantity-${indexCart}`).value;
    const isPresale = that.getAttribute('data-is-presale');


	const props = {
		"_deals_crafter_bundle_name": bundle_handle,
        //"_line_item_uid": Date.now().toString() + Math.random().toString(36).substring(2, 8),
        //"_bundle_item_position": `item_${indexCart + 1}`,
		"Bundle": bundle_handle,
		//"_bundle_unique_id": bundle_unique_id,
		"_bundle_subscription": true,
		"_subscription_filter_interval": selectedInterval,
		"_subscription_filter_date": newDate,
		"_subscription_available_plans": plans,
		"_subscription_available_intervals": result,
		"_subscription_filter_title": title,
		"_subscription_filter_price": price,
		"_subscription_filter_image": image,
        "_presale_discount": isPresale
	};



	//TRACKING BUNDLES SUBSCRIPTION
	dataLayer.push({ eventModel: null });

	let ecommAddToCartGA4 = {
		event: "add_bundle_subscription",
		eventModel: {
			currency: "USD",
			ecomm_totalvalue: productPrice,
			items: [{
				item_id: product,
				item_name: productName,
				item_category: 'Bundles',
				price: productPrice,
				quantity: qty,
				purchase_type: 'Subscription'
			}]
		}
	};
	console.log("GA4 Bundle Subscription:",ecommAddToCartGA4);

	dataLayer.push(ecommAddToCartGA4);

	replaceCartLineWithSubscription(product, cartObj.route, props, qty, selling_plan, indexCart)
		.then(() => location.reload())
		.catch(error => console.error("Error BUNDLE:", error));
}

function addCartLine(productId, cartRoutes,qty, selling_plan, properties) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: cartRoutes.add,
      method: 'POST',
      dataType: 'json',
      data: {
        id: productId,
        quantity: qty,
        selling_plan: selling_plan,
        properties: properties
      },
      success: resolve,
      error: reject
    });
  });
}

function removeCartLine(lineIndex, cartRoutes) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: cartRoutes.change,
      method: 'POST',
      data: {
        line: lineIndex,
        quantity: 0
      },
      success: resolve,
      error: reject
    });
  });
}

function replaceCartLineWithSubscription(product_id, cartRoutes, properties, qty, selling_plan = '', cartIndex) {
  return new Promise((resolve, reject) => {
    properties["_line_item_uid"] = Date.now().toString() + Math.random().toString(36).substring(2, 8);

    removeCartLine(cartIndex, cartRoutes)
      .then(() => addCartLine(product_id, cartRoutes,qty, selling_plan, properties))
      .then(resolve)
      .catch(reject);
  });
}

function deleteItemFromCart(url_change, item_line, qty)
{
  	return new Promise((resolve, reject) => {
  		$.ajax({
  			url: url_change,
  			method: 'POST',
  			data: {
  				line: item_line,
  				quantity: qty
  			},
  			success: function (response) {
  				resolve(response);
  			},
  			error: function (error) {
  				console.log(">>> deleteItemFromCart ERROR: ", error);
  				reject(error);

  			}
  		});
  	})
}

function changeCartItem(url_change, props)
{
	return new Promise((resolve, reject) => {
		$.ajax({
			url: url_change,
			method: 'POST',
			data: props,
			success: function (response) {
				resolve(response);
			},
			error: function (error) {
				console.log(">>> deleteItemFromCart ERROR: ", error);
				reject(error);

			}
		});
	})
}

function addToCartWithRechargeSub(product_id,cart_url, properties, qty, selling_plan = '', cartIndex,delivery_date = '',original_price = '')
{
	if(delivery_date != '')
		properties.properties["Estimated delivery"] = delivery_date;

	if(original_price != '')
		properties.properties["_original_product_price"] = original_price;

	let props = {
		"line": cartIndex,
		"id": product_id,
		"quantity": document.getElementById(`Quantity-${cartIndex}`).value,
		"selling_plan": properties.properties['_subscription_selling_plan'],
		"properties": properties.properties
	}

	return new Promise((resolve, reject) => {
		$.ajax({
			url: cart_url,
			method: 'POST',
			data: props,
			success: function (response) {
				resolve(response);
			},
			error: function (error) {
				console.log(">>> addToCartWithRechargeSub ERROR: ", error);
				reject(error);
			}
		});
	})
}

function updateCartBundleSub(product_id, url, properties, qty, selling_plan = '', cartIndex)
{

	let props = {
		"line": cartIndex,
		"id": product_id,
		"quantity": qty,
		"selling_plan": selling_plan,
		"properties": properties
	}

   console.log(">> PROPS",props);
  console.log(">>> INDEX", cartIndex);

	return new Promise((resolve, reject) => {
		$.ajax({
			url: url,
			method: 'POST',
			data: props,
			success: function (response) {
              console.log(">>> RESPONSE: ", response);
				resolve();
			},
			error: function (error) {
				console.log(">>> Bundle change cart ERROR: ", error);
				reject(error);
			}
		});
	})
}

let cartSelectInterval = document.querySelectorAll('.recharge-cart-select');
let cartBundleSelectInterval = document.querySelectorAll('.recharge-cart-bundle-select');

cartBundleSelectInterval.forEach((element) => {
	element.addEventListener('change', function(event) {
		let selectedInterval = event.target.value;
		let newDate = addMonthToDate(selectedInterval);
		let selectEl = event.target;
		let selectedIndex = selectEl.options.selectedIndex;
		let selectedSellingPlan = selectEl.options[selectedIndex].dataset.sellingPlan;
		let item_index = selectEl.getAttribute('data-item');
		let product_id = selectEl.getAttribute('data-id');
		let propsStr = selectEl.dataset.properties;
		let qty = document.getElementById(`Quantity-${item_index}`).value;

		var propsArray = JSON.parse(propsStr);

		var propsObj = {};
		propsArray.forEach(function(item) {
			propsObj[item[0]] = item[1];
		});


		propsObj._subscription_filter_interval  = selectedInterval;
		propsObj._subscription_filter_date		= newDate;

		replaceCartLineWithSubscription(product_id, cartObj.route, propsObj, qty, selectedSellingPlan, item_index)
			.then(() => location.reload())
			.catch(error => console.error("Error BUNDLE:", error));
	
	});
});


cartSelectInterval.forEach((element) => {
	element.addEventListener('change', function(event) {
		let selectedInterval = event.target.value;

		let newDate = addMonthToDate(selectedInterval);

		let that = event.target;
		let selectedIndex = that.options.selectedIndex;
		let selectedSellingPlan = that.options[selectedIndex].dataset.sellingPlan;

		let delivery_date = '';

		if (that.hasAttribute('data-delivery-date')) {
			delivery_date = that.getAttribute('data-delivery-date');
		}

		let item_index = that.getAttribute('data-item');
		let original_price = that.getAttribute('data-original-price');
		let futureDateEl = document.getElementById(`imp-cart-future-date-${item_index}`);

		let productType = futureDateEl.getAttribute("data-product-type");

		if(productType == "Scents")
			futureDateEl.innerHTML = `Scents ships ${newDate}`;
		else
			futureDateEl.innerHTML = `Filter ships ${newDate}`;

		let sufix = that.getAttribute('data-product-selected');

		if(sufix == '' || sufix == undefined)
			sufix = that.getAttribute('data-id');

		let cookieName = `_recharge_properties_${sufix}`;

		getJsonCookie(cookieName)
			.then(subs_cookie => {
				const newValues = {
					"_subscription_filter_interval" : selectedInterval,
					"_subscription_filter_date": newDate,
					"Estimated delivery": delivery_date,
					"_original_product_price": original_price,
				};

				if(newValues['Estimated delivery'] === '')
					delete newValues["Estimated delivery"];

				const properties = {
					"properties" : {...subs_cookie.properties, ...newValues}
				}

				let props = {
					"line": item_index,
					"properties": properties.properties,
					"price": 50000,
					"selling_plan": selectedSellingPlan,
					"quantity": document.getElementById(`Quantity-${item_index}`).value
				}


				updateCookie(cookieName,properties)
				.then(res => {
					changeCartItem(cartObj.route.change,props)
					.then(() => {
					location.reload();
					})
				})
				})
			.catch(error => {
				console.log(">>> No se econtro la cookie");
			})
	});
});
/*IMPROVING RECHARGE CODE END*/


/*IMPROVING REMOVE AGENT FROM CART CODE START*/

const removeAgentLink = document.querySelector('.js-clear-attribution');

if(removeAgentLink) {
	removeAgentLink.addEventListener('click', (event) => {
		const updateBody = {
			attributes: {
				Agent: null
			}
		};

		let xhr = new XMLHttpRequest();

		xhr.open("POST", '/cart/update.js', true);
		xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

		xhr.onreadystatechange = function () {
			if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
				window.location = '/cart';
			}
		}

		xhr.send(JSON.stringify(updateBody));

	});
}


/*IMPROVING REMOVE AGENT FROM CART CODE end*/
